import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useAuth } from "@/context/AuthContext";
import { LogOut, KeyRound } from "lucide-react";
import ChangePasswordModal from "@/components/ChangePasswordModal";

export default function TopBar() {
  const { t, i18n } = useTranslation();
  const { user, logout } = useAuth();
  const [showCp, setShowCp] = useState(false);
  const switchLang = (l) => { i18n.changeLanguage(l); localStorage.setItem("lang", l); };
  return (
    <header className="topbar">
      <div className="topbar-inner">
        <div className="brand" data-testid="app-brand">
          <div className="brand-mark">SH</div>
          <div>StepHub HR</div>
        </div>
        <div className="topbar-right">
          <div className="lang-toggle" data-testid="lang-toggle">
            <button data-testid="lang-ja" className={i18n.language === "ja" ? "active" : ""} onClick={() => switchLang("ja")}>日本語</button>
            <button data-testid="lang-en" className={i18n.language === "en" ? "active" : ""} onClick={() => switchLang("en")}>EN</button>
          </div>
          {user && (
            <div className="user-chip" data-testid="user-chip">
              <div className="avatar">{(user.name || "?").slice(0, 1)}</div>
              <div style={{ display: "flex", flexDirection: "column", lineHeight: 1.15 }}>
                <span className="user-info-name" style={{ fontWeight: 600 }}>{user.name}</span>
                <span className="user-info-role" style={{ fontSize: 11, color: "#64748B" }}>{user.role}</span>
              </div>
              <button className="btn btn-outline" style={{ padding: "6px 10px" }} onClick={() => setShowCp(true)} data-testid="change-pw-btn" title={t("common.changePassword")} aria-label={t("common.changePassword")}>
                <KeyRound size={14} /> <span className="btn-label">{t("common.changePassword")}</span>
              </button>
              <button className="btn btn-outline" style={{ padding: "6px 10px" }} onClick={logout} data-testid="logout-btn" title={t("common.logout")} aria-label={t("common.logout")}>
                <LogOut size={14} /> <span className="btn-label">{t("common.logout")}</span>
              </button>
            </div>
          )}
        </div>
      </div>
      {showCp && <ChangePasswordModal onClose={() => setShowCp(false)} />}
    </header>
  );
}
